module.exports = __webpack_public_path__ + "img/2018-12-16-5.fd3aecdd.jpeg";